import AddOrdersActionsMenu from './Menu';
import AddOrdersActionsImportDialogs from './ImportDialogs';

const AddOrdersActionsComponents = {
  Menu: AddOrdersActionsMenu,
  ImportDialogs: AddOrdersActionsImportDialogs,
};

export default AddOrdersActionsComponents;
